// extracted by mini-css-extract-plugin
module.exports = {"cart-button":"main-nav-cart-button__cart-button___1FSmi","cart-icon-badge":"main-nav-cart-button__cart-icon-badge___2P0fC"};